<template>
  <div class="blocDateRange">
    <v-date-picker
      v-model="dates"
      v-bind="$attrs"
      range
      :locale="datePickerLocales[$store.getters.lang]"
      :landscape="customLandscape"
      v-on="$listeners"
    />
    <v-text-field
      v-model="dateRangeText"
      prependIcon="event"
      :label="$t('generic.dateRange')"
      readonly
    />
  </div>
</template>
<script>
import moment from 'moment';
import _datePickerLocales from '@/locales/date-picker-locales';

export default {
    data() {
        return {
            dates: [],
            formattedDates: [],
            customLandscape: false,
        };
    },
    computed: {
        dateRangeText() {
            return this.formattedDates.map(date => this.$options.filters.formatDate(date, 'L')).join(' ~ ');
        },
        lang() {
            return this.$store.getters.lang;
        },
        datePickerLocales() {
            return _datePickerLocales;
        },
    },
    watch: {
        lang() {
            // If we change languages, we reset the date, the formatting is not the same
            this.dates = [];
        },
        dates() {
            this.dates.map(date => moment(date));
            this.formattedDates = this.dates;
            this.$emit('change', this.formattedDates);
        },
    },
    mounted() {
        this.updateCustomLandscape();
        window.addEventListener('resize', this.updateCustomLandscape);
    },
    beforeUnmount() {
        window.removeEventListener('resize', this.updateCustomLandscape);
    },
    methods: {
        updateCustomLandscape() {
            this.customLandscape = window.innerWidth > 600;
        },
    // ...
    },
};
</script>

<style lang="scss">
    @media screen and (max-width: 600px) {
        .blocDateRange {
            .v-picker {
                margin-bottom: 20px
            }
        }
    }
</style>
